import * as R from 'ramda';

import { fromJS } from 'immutable';

import { fetchingState } from '@constants';

import * as builderPlanActions from '../actions/builderplan';
import { SUCCESS, START, ERROR } from '../actions/global';

const initialStats = {
  builderNames: {},
  builderPlan: {},
  builderPlansBySearch: {},
  builderPlanSketch: {},
  searchConfigs: {},
  searchFormData: {},
  pagination: {
    count: 0,
    page: 1,
    rowsPerPage: 50,
    rowsPerPageOptions: [50, 100, 1000, 5000, 10000],
  },
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case builderPlanActions.BUILDER_PLANS_SEARCH[START]:
      return state
        .setIn(['builderPlansBySearch', 'state'], fetchingState.FETCHING)
        .setIn(['pagination', 'page'], action.page)
        .setIn(['pagination', 'rowsPerPage'], action.pageSize);

    case builderPlanActions.BUILDER_PLANS_SEARCH[SUCCESS]:
      return state
        .setIn(['builderPlansBySearch', 'state'], fetchingState.LOADED)
        .setIn(
          ['builderPlansBySearch', 'total'],
          fromJS(
            R.pathOr(
              0,
              ['data', 'totalBuilderPlans', 'builderPlanCount'],
              action,
            ),
          ),
        )
        .setIn(
          ['builderPlansBySearch', 'total'],
          fromJS(
            R.pathOr(
              0,
              ['data', 'totalBuilderPlans', 'builderPlanCount'],
              action,
            ),
          ),
        )
        .setIn(
          ['builderPlansBySearch', 'data'],
          fromJS(R.pathOr([], ['data', 'results'], action)),
        )
        .setIn(
          ['pagination', 'count'],
          fromJS(
            R.pathOr(
              0,
              ['data', 'totalBuilderPlans', 'builderPlanCount'],
              action,
            ),
          ),
        );

    case builderPlanActions.BUILDER_PLANS_SEARCH[ERROR]:
      return state.setIn(
        ['builderPlansBySearch', 'state'],
        fetchingState.ERROR,
      );
    case builderPlanActions.DELETE_BUILDER_PLAN[SUCCESS]:
      const data = state.getIn(['builderPlansBySearch', 'data']).toJS();
      let newState = state.setIn(
        ['builderPlansBySearch', 'total'],
        state.getIn(['builderPlansBySearch', 'total']) - 1,
      );
      return newState.setIn(
        ['builderPlansBySearch', 'data'],
        fromJS(data.filter(d => d.builderPlanID !== action.builderPlanID)),
      );
    case builderPlanActions.BUILDER_PLANS_SEARCH_RESET:
      return state.setIn(['builderPlansBySearch', 'data'], fromJS([]));
    case builderPlanActions.GET_SEARCH_CONFIGS_FOR_BP[START]:
      return state.setIn(['searchConfigs', 'state'], fetchingState.FETCHING);
    case builderPlanActions.GET_SEARCH_CONFIGS_FOR_BP[SUCCESS]:
      newState = state.setIn(['searchConfigs', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['searchConfigs', 'data'],
        fromJS(R.pathOr([], ['data', 'results'], action)),
      );
    case builderPlanActions.GET_SEARCH_CONFIGS_FOR_BP[ERROR]:
      return state.setIn(['searchConfigs', 'state'], fetchingState.ERROR);
    case builderPlanActions.FETCH_BUILDER_NAMES[START]:
      return state.setIn(['builderNames', 'state'], fetchingState.FETCHING);
    case builderPlanActions.FETCH_BUILDER_NAMES[SUCCESS]:
      newState = state.setIn(['builderNames', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['builderNames', 'data'],
        fromJS(R.pathOr([], ['data', 'results'], action)),
      );
    case builderPlanActions.FETCH_BUILDER_NAMES[ERROR]:
      return state.setIn(['builderNames', 'state'], fetchingState.ERROR);
    case builderPlanActions.FETCH_BUILDER_PLAN[START]:
      return state.setIn(['builderPlan', 'state'], fetchingState.FETCHING);
    case builderPlanActions.FETCH_BUILDER_PLAN[SUCCESS]:
      newState = state.setIn(['builderPlan', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['builderPlan', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case builderPlanActions.FETCH_BUILDER_PLAN[ERROR]:
      return state.setIn(['builderPlan', 'state'], fetchingState.ERROR);
    case builderPlanActions.FETCH_BUILDER_PLAN_SKETCH[START]:
      return state.setIn(
        ['builderPlanSketch', 'state'],
        fetchingState.FETCHING,
      );
    case builderPlanActions.FETCH_BUILDER_PLAN_SKETCH[SUCCESS]:
      newState = state.setIn(
        ['builderPlanSketch', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['builderPlanSketch', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case builderPlanActions.FETCH_BUILDER_PLAN_SKETCH[ERROR]:
      return state.setIn(['builderPlanSketch', 'state'], fetchingState.ERROR);

    case builderPlanActions.FETCH_BUILDER_PLAN_VALUATION[START]:
      return state.setIn(
        ['builderPlanValuation', 'state'],
        fetchingState.FETCHING,
      );
    case builderPlanActions.FETCH_BUILDER_PLAN_VALUATION[SUCCESS]:
      newState = state.setIn(
        ['builderPlanValuation', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['builderPlanValuation', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case builderPlanActions.FETCH_BUILDER_PLAN_VALUATION[ERROR]:
      return state.setIn(
        ['builderPlanValuation', 'state'],
        fetchingState.ERROR,
      );
    case builderPlanActions.SET_SEARCH_FORM_DATA: {
      return state.setIn(['searchFormData'], fromJS(action.payload));
    }
    case builderPlanActions.CHANGE_PAGE: {
      return state.setIn(['pagination', 'page'], action.payload);
    }
    case builderPlanActions.CHANGE_ROWS_PER_PAGE: {
      return state.setIn(['pagination', 'rowsPerPage'], action.payload);
    }
    default:
      return state;
  }
};
